<header class="modal-header">
    <h4 class="modal-title">Sager til godkendelse</h4>
    <button (click)="onClose()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</header>


<section class="modal-body">
    <table *ngIf="sagerTilGodkendelse$ | async as sagerTilGodkendelse"
           class="table table-hover table-striped table-sm">
        <thead>
        <th>Kundenr</th>
        <th>Kunde</th>
        <th>Sag</th>
        <th>Regnskabsår</th>
        <th>Anmodning</th>
        </thead>
        <tbody>
        <tr *ngFor="let item of sagerTilGodkendelse"
            class="clickable"
            (click)="onGotoGodkendelse(item)">
            <td>{{item?.glkundenr}}</td>
            <td>{{item.navn1}} {{item.navn2 ? ', ' + item.navn2 : ''}}</td>
            <td>{{item.beskrivelse}}</td>
            <td>{{item.regnskabsaar}}</td>
            <td>{{item.anmodetTid | date:'dd-MM-yyyy'}} - {{item.anmodetAf}}</td>
        </tr>
        </tbody>
    </table>
</section>
